/**
 * @file Generated by js-routes 2.3.7. Based on Rails 8.1.3.1 routes of VolumeTracker::Application.
 * @version 76d44707386240690cad9e4853770e5b03fe57817d06de6477ea8464efef4be1
 * @see https://github.com/railsware/js-routes
 */
"use strict";
const __jsr = (() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    // Some javascript processors (like vite/rolldown)
                    // warn on using module dot exports in an ESM module.
                    // This just obfuscates that assignment a little so
                    // users don't get a warning they can't fix.
                    const _mod = module;
                    _mod.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using RubyVariables . WRAPPER
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    false
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false && result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r: utils.route.bind(utils),
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: utils.configure.bind(utils),
        config: utils.config.bind(utils),
        serialize: utils.serialize.bind(utils),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /identity/invitations/accept/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acceptIdentityInvitationsPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"accept"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/console(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminConsolePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"console"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_archive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailArchivePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_archive"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_archive/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailArchiveDownloadPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_archive"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_archive/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailArchivePreviewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_archive"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOutreachPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/switch_tenant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSwitchTenantPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"switch_tenant"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/facilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FacilitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"facilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/facilities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FacilityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/facilities/:facility_id/notification_settings(.:format)
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FacilityNotificationSettingsPath = /*#__PURE__*/ __jsr.r({"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/facilities/:facility_id/webhooks/:id(.:format)
 * @param {any} facilityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FacilityWebhookPath = /*#__PURE__*/ __jsr.r({"facility_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/facilities/:facility_id/webhooks(.:format)
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FacilityWebhooksPath = /*#__PURE__*/ __jsr.r({"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/feature_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1FeatureFlagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ingest/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1IngestEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ingest"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:org_slug/facilities(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1OrgFacilitiesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:org_slug/facilities/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1OrgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:org_slug/facilities/:facility_id/notification_settings(.:format)
 * @param {any} orgSlug
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1OrgFacilityNotificationSettingsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:org_slug/facilities/:facility_id/webhooks/:id(.:format)
 * @param {any} orgSlug
 * @param {any} facilityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1OrgFacilityWebhookPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"facility_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:org_slug/facilities/:facility_id/webhooks(.:format)
 * @param {any} orgSlug
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1OrgFacilityWebhooksPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1RegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiV1SessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/inbox/:id/attach(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachLegacyOrgInboxPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/inbox/:id/attach(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachOrgInboxPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/board(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const boardLegacyOrgWorkOrdersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"board"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/board(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const boardOrgWorkOrdersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[6,"board"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /claim/:org_slug(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claimPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[3,"org_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/riders/contracts/:document_id/confirm(.:format)
 * @param {any} orgSlug
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmContractLegacyOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/riders/contracts/:document_id/confirm(.:format)
 * @param {any} orgSlug
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmContractOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/invitations/confirm/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmIdentityInvitationsPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"confirm"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/inbox/:id/confirm(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmLegacyOrgInboxPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/:id/confirm(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmLegacyOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/inbox/:id/confirm(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmOrgInboxPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/:id/confirm(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/facilities/:facility_id/webhooks/:id/deliveries(.:format)
 * @param {any} facilityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliveriesApiV1FacilityWebhookPath = /*#__PURE__*/ __jsr.r({"facility_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/:org_slug/facilities/:facility_id/webhooks/:id/deliveries(.:format)
 * @param {any} orgSlug
 * @param {any} facilityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliveriesApiV1OrgFacilityWebhookPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"facility_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access_grants/destroy_all(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAllLegacyOrgAccessGrantsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_grants"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access_grants/destroy_all(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyAllOrgAccessGrantsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_grants"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/:id/download(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadLegacyOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/:id/download(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /facilities/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editFacilityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editIdentityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/cars/:id/edit(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLegacyOrgCarPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/facilities/:id/edit(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editLegacyOrgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/cars/:id/edit(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrgCarPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/facilities/:id/edit(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editOrgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/:id/email_preview(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailPreviewLegacyOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/:id/email_preview(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emailPreviewOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /facilities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facilitiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"facilities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /facilities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facilityPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /facilities/:facility_id/notifications(.:format)
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facilityNotificationsPath = /*#__PURE__*/ __jsr.r({"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/feature_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const featureAccessAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/session/google(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const googleApiV1SessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"google"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /healthz/queue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthzQueuePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthz"],[2,[7,"/"],[2,[6,"queue"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/email_verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityEmailVerificationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"email_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgAccessPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access_entitlements(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgAccessEntitlementsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_entitlements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access_grants/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgAccessGrantPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access_grants(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgAccessGrantsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_grants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access_invitations(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgAccessInvitationsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/access_users/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgAccessUserPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/api_tokens/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgApiTokenPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/api_tokens(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgApiTokensPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"api_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/branding/:name(.:format)
 * @param {any} orgSlug
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgBrandingPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/cars/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgCarPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/cars/:car_id/qual_items(.:format)
 * @param {any} orgSlug
 * @param {any} carId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgCarQualItemsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"car_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[3,"car_id"],[2,[7,"/"],[2,[6,"qual_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/cars(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgCarsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgCloudDashboardPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/customers(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgCustomersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/facilities(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgFacilitiesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/facilities/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/facilities/:facility_id/notifications(.:format)
 * @param {any} orgSlug
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgFacilityNotificationsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/fleet_chat(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgFleetChatPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"fleet_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/fleet_chat(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgFleetChatTurnPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"fleet_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/inbox(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgInboxIndexPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/lessors/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgLessorPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"lessors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/lessors(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgLessorsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"lessors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/notifications/mark_read(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgMarkNotificationsReadPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/master_data(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgMasterDataPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"master_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/master_data/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgMasterDatumPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"master_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/members/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgMemberPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/members(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgMembersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/notifications(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgNotificationsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/settings(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgOrgSettingsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/report_subscriptions/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportSubscriptionPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"report_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/report_subscriptions(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportSubscriptionsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"report_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/subscriptions(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportSubscriptionsOverviewPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/:report_id/views/:id(.:format)
 * @param {any} orgSlug
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportViewPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/:report_id/views(.:format)
 * @param {any} orgSlug
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportViewsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgReportsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/requal(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgRequalPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"requal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/riders(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/saved_report_recipients/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgSavedReportRecipientPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"saved_report_recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/saved_report_recipients(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgSavedReportRecipientsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"saved_report_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/savings(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgSavingsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"savings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/scorecards/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgScorecardPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/scorecards(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgScorecardsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"scorecards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/shops(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgShopsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"shops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/:work_order_id/correspondences(.:format)
 * @param {any} orgSlug
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgWorkOrderCorrespondencesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"correspondences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/:work_order_id/pod_commitments(.:format)
 * @param {any} orgSlug
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgWorkOrderPodCommitmentsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"pod_commitments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgWorkOrdersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/workspaces/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgWorkspacePath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"workspaces"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/workspaces(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacyOrgWorkspacesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /litestream
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const litestreamPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"litestream"]]);

/**
 * Generates rails route to
 * /litestream/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const litestreamProcessPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"litestream"]],[7,"/"]]);

/**
 * Generates rails route to
 * /litestream/restorations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const litestreamRestorationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"litestream"]],[7,"/"]],[2,[6,"restorations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /litestream/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const litestreamRootPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"litestream"]],[7,"/"]]);

/**
 * Generates rails route to
 * /notifications/mark_read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const markNotificationsReadPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/membership(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membershipAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"jobs"]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_discards(.:format)
 * @param {any} applicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationBulkDiscardsPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_discards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_retries(.:format)
 * @param {any} applicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationBulkRetriesPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:id(.:format)
 * @param {any} applicationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationJobPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/discard(.:format)
 * @param {any} applicationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationJobDiscardPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/dispatch(.:format)
 * @param {any} applicationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationJobDispatchPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/retry(.:format)
 * @param {any} applicationId
 * @param {any} jobId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationJobRetryPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/:status/jobs(.:format)
 * @param {any} applicationId
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationJobsPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:id(.:format)
 * @param {any} applicationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationQueuePath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:queue_id/pause(.:format)
 * @param {any} applicationId
 * @param {any} queueId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationQueuePausePath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"queue_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"queue_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues(.:format)
 * @param {any} applicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationQueuesPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks/:id(.:format)
 * @param {any} applicationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationRecurringTaskPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks(.:format)
 * @param {any} applicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationRecurringTasksPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers/:id(.:format)
 * @param {any} applicationId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationWorkerPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers(.:format)
 * @param {any} applicationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsApplicationWorkersPath = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:status/jobs(.:format)
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsJobsPath = /*#__PURE__*/ __jsr.r({"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsQueuePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsQueuesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missionControlJobsRootPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"jobs"]],[7,"/"]]);

/**
 * Generates rails route to
 * /admin
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"admin"]]);

/**
 * Generates rails route to
 * /admin/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"admin"]],[7,"/"]]);

/**
 * Generates rails route to
 * /admin/api/data/active_storage__attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiActiveStorageAttachmentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"active_storage__attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/alerts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiAlertPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiAlertsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/api_configs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiApiConfigPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"api_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/api_configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiApiConfigsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"api_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/audits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiAuditsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"audits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/auth_tokens(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiAuthTokensPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"auth_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/configs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiConfigsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"configs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/dashboards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiDashboardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiDashboardsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiFormsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/icons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiIconsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"icons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiNotePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/note_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiNoteTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"note_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiNotesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiNotificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiQueriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiQueryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/reminders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiReminderPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiRemindersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/data/:resource/:id(.:format)
 * @param {any} resource
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiResourcePath = /*#__PURE__*/ __jsr.r({"resource":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[3,"resource"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/data/:resource/:resource_id/:association(.:format)
 * @param {any} resource
 * @param {any} resourceId
 * @param {any} association
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiResourceAssociationIndexPath = /*#__PURE__*/ __jsr.r({"resource":{"r":true},"resource_id":{"r":true},"association":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[3,"resource"],[2,[7,"/"],[2,[3,"resource_id"],[2,[7,"/"],[2,[3,"association"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/resource_default_queries/:resource(.:format)
 * @param {any} resource
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiResourceDefaultQueryPath = /*#__PURE__*/ __jsr.r({"resource":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"resource_default_queries"],[2,[7,"/"],[2,[3,"resource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/resource_methods/:resource(.:format)
 * @param {any} resource
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiResourceMethodPath = /*#__PURE__*/ __jsr.r({"resource":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"resource_methods"],[2,[7,"/"],[2,[3,"resource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/resources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiResourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/run_api_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiRunApiRequestPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"run_api_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/run_graphql_request(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiRunGraphqlRequestPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"run_graphql_request"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/run_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiRunQueriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"run_queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/run_queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiRunQueryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"run_queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/schema/:resource(.:format)
 * @param {any} resource
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiSchemaPath = /*#__PURE__*/ __jsr.r({"resource":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"schema"],[2,[7,"/"],[2,[3,"resource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/schema(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiSchemaIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/send_alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiSendAlertsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"send_alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/slack_conversations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiSlackConversationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"slack_conversations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api/users_for_autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorApiUsersForAutocompleteIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"api"],[2,[7,"/"],[2,[6,"users_for_autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/assets/:filename
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorAssetPath = /*#__PURE__*/ __jsr.r({"filename":{"r":true}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"assets"],[2,[7,"/"],[3,"filename"]]]]);

/**
 * Generates rails route to
 * /admin/cable
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorCablePath = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[6,"cable"]]);

/**
 * Generates rails route to
 * /admin/alerts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiAlertPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/alerts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiAlertsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiDashboardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiDashboardsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"dashboards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/data(/*path)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiDataPath = /*#__PURE__*/ __jsr.r({"path":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"data"],[2,[1,[2,[7,"/"],[5,[3,"path"]]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiFormsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiNotificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiQueriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiQueryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiReportPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminMotorUiReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/alerts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminNewMotorUiAlertPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dashboards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminNewMotorUiDashboardPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"dashboards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminNewMotorUiFormPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/queries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const motorAdminNewMotorUiQueryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"queries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /facilities/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newFacilityPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity/password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newIdentityPasswordResetPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity"],[2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/cars/new(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLegacyOrgCarPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/facilities/new(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLegacyOrgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/cars/new(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrgCarPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/facilities/new(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newOrgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauthCallbackPath = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauthFailurePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /demo/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingCheckEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /demo/click(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingClickPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"click"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingNewPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"demo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /provisioning/:org_slug(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingProvisioningPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"provisioning"],[2,[7,"/"],[2,[3,"org_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /demo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingTryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"demo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgAccessPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access_entitlements(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgAccessEntitlementsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_entitlements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access_grants/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgAccessGrantPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access_grants(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgAccessGrantsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_grants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access_invitations(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgAccessInvitationsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_invitations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/access_users/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgAccessUserPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"access_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/api_tokens/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgApiTokenPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"api_tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/api_tokens(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgApiTokensPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"api_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/branding/:name(.:format)
 * @param {any} orgSlug
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgBrandingPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"branding"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/cars/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgCarPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/cars/:car_id/qual_items(.:format)
 * @param {any} orgSlug
 * @param {any} carId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgCarQualItemsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"car_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[2,[7,"/"],[2,[3,"car_id"],[2,[7,"/"],[2,[6,"qual_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/cars(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgCarsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"cars"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgCloudDashboardPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:org_slug/customers(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgCustomersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/facilities(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgFacilitiesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/facilities/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgFacilityPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/facilities/:facility_id/notifications(.:format)
 * @param {any} orgSlug
 * @param {any} facilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgFacilityNotificationsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"facility_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"facilities"],[2,[7,"/"],[2,[3,"facility_id"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/fleet_chat(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgFleetChatPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"fleet_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/fleet_chat(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgFleetChatTurnPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"fleet_chat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/inbox(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgInboxIndexPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/lessors/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgLessorPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"lessors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/lessors(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgLessorsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"lessors"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/notifications/mark_read(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgMarkNotificationsReadPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"mark_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/master_data(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgMasterDataPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"master_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/master_data/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgMasterDatumPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"master_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/members/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgMemberPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/members(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgMembersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/notifications(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgNotificationsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/settings(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgOrgSettingsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/report_subscriptions/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportSubscriptionPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"report_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/report_subscriptions(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportSubscriptionsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"report_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/subscriptions(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportSubscriptionsOverviewPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/:report_id/views/:id(.:format)
 * @param {any} orgSlug
 * @param {any} reportId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportViewPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"report_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/:report_id/views(.:format)
 * @param {any} orgSlug
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportViewsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgReportsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/requal(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgRequalPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"requal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/riders(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/saved_report_recipients/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgSavedReportRecipientPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"saved_report_recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/saved_report_recipients(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgSavedReportRecipientsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"saved_report_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/savings(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgSavingsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"savings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/scorecards/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgScorecardPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/scorecards(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgScorecardsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"scorecards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/shops(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgShopsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"shops"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/:work_order_id/correspondences(.:format)
 * @param {any} orgSlug
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgWorkOrderCorrespondencesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"correspondences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/:work_order_id/pod_commitments(.:format)
 * @param {any} orgSlug
 * @param {any} workOrderId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgWorkOrderPodCommitmentsPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"work_order_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"work_order_id"],[2,[7,"/"],[2,[6,"pod_commitments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgWorkOrdersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/workspaces/:id(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgWorkspacePath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"workspaces"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/workspaces(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orgWorkspacesPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"workspaces"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/:id/otma_package(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otmaPackageLegacyOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"otma_package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/:id/otma_package(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const otmaPackageOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"otma_package"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /demo/start/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outreachDemoPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"demo"],[2,[7,"/"],[2,[6,"start"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outreachInvitesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/scorecards/:id/recompute(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recomputeLegacyOrgScorecardPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recompute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/scorecards/:id/recompute(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recomputeOrgScorecardPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recompute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/riders/contracts/:document_id/reject(.:format)
 * @param {any} orgSlug
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectContractLegacyOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/riders/contracts/:document_id/reject(.:format)
 * @param {any} orgSlug
 * @param {any} documentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectContractOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"document_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"document_id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/inbox/:id/reject(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectLegacyOrgInboxPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/work_orders/:id/reject(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectLegacyOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/inbox/:id/reject(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectOrgInboxPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/work_orders/:id/reject(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rejectOrgWorkOrderPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"work_orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /orgs/:org_slug/reports/:id/send(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendLegacyOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/reports/:id/send(.:format)
 * @param {any} orgSlug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendOrgReportPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/handoff(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessionHandoffPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"handoff"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/appearance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsAppearancePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"appearance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsProfilePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsSessionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signInPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signUpPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /try(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"try"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /try/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tryCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"try"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /try/click(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tryClickPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"try"],[2,[7,"/"],[2,[6,"click"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboRecedeHistoricalLocationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboRefreshHistoricalLocationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turboResumeHistoricalLocationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /n/u/:kind/:token(.:format)
 * @param {any} kind
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribeNotificationPath = /*#__PURE__*/ __jsr.r({"kind":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"n"],[2,[7,"/"],[2,[6,"u"],[2,[7,"/"],[2,[3,"kind"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/u/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribeReportPath = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[6,"u"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orgs/:org_slug/riders/upload_contract(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadContractLegacyOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orgs"],[2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[2,[7,"/"],[2,[6,"upload_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:org_slug/riders/upload_contract(.:format)
 * @param {any} orgSlug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadContractOrgRidersPath = /*#__PURE__*/ __jsr.r({"org_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"org_slug"],[2,[7,"/"],[2,[6,"riders"],[2,[7,"/"],[2,[6,"upload_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/session/web_handoff(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webHandoffApiV1SessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"web_handoff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

